import { addVisible, removeVisible } from './helper';

const CLS = '.validate--tooltip-maxlength';

export function validateMaxLength(element: HTMLInputElement, maxLen: number): boolean {
    if (element.value.length > maxLen) {
        addVisible(element, CLS);
        return false;
    } else {
        removeVisible(element, CLS);
        return true;
    }
}

export function liveValidateMaxLength(element: HTMLInputElement) {
    const maxLen = parseInt(element.getAttribute('maxlength') as string, 10);
    if (isNaN(maxLen)) {
        return;
    }

    // We need to check every keypress to make pulse nice.
    element.addEventListener('keypress', (e: Event) => {
        const keyboardEvent = e as KeyboardEvent;

        // Allow special keys (Backspace, Delete, Arrow keys, etc.)
        const allowedKeys = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Tab'];
        if (allowedKeys.includes(keyboardEvent.key)) {
            return;
        }

        // Check if there is a text selection in the input field.
        // Note: selectionStart/selectionEnd work correctly in modern browsers for input and textarea elements.
        // In older browsers (IE, Edge Legacy), these properties may not be available, hence the try-catch.
        try {
            const selStart = element.selectionStart;
            const selEnd = element.selectionEnd;
            if (selStart !== null && selEnd !== null) {
                if (selStart - selEnd !== 0) {
                    // Len is currently 15, but as there is selection it will be < 15.
                    return;
                }
            }
        } catch (exception) {
            // selectionStart/selectionEnd may not be supported in older browsers.
            // This doesn't affect functionality, but log for debugging purposes.
            console.error('Error accessing selection properties:', exception);
        }

        element.classList.remove('pulse--validate-maxlength');
        if (element.value.length >= maxLen) {
            // Trigger reflow to ensure CSS animation restarts properly
            setTimeout(() => {
                element.classList.add('pulse--validate-maxlength');
            }, 0);
            e.preventDefault();
            return false;
        }
        return;
    });

    element.addEventListener('input', (e: Event) => {
        return validateMaxLength(element, maxLen);
    });
    element.addEventListener('change', (e: Event) => {
        return validateMaxLength(element, maxLen);
    });
    element.addEventListener('blur', (e: Event) => {
        return validateMaxLength(element, maxLen);
    });
}
